import React, { Component } from "react";
import sectiondata from "../../data/sections.json";
import parse from "html-react-parser";
import mapboxgl from "mapbox-gl";

import { useDispatch, useSelector } from "react-redux";
import { propertyFetchThunk } from "../../features/properties/properties";
import { Link } from "react-router-dom";

function SearchMap() {
  const dispatch = useDispatch();
  let publicUrl = "../../"; //process.env.PUBLIC_URL+'/'
  let imagealt = "image";
  let data = sectiondata.searchgrid;
  let searchlist = sectiondata.searchlist;

  React.useEffect(() => {
    dispatch(propertyFetchThunk());
    return () => {};
  }, []);

  const propertyState = useSelector((state) => state.properties);
  console.log(propertyState, " property state component");

  return (
    <div className="search-page-area ">
      <div className="search-container">
        {/* search map start */}
        <div className="search-page-search-wrap">
          <div className="search-page-map">
            {/* <div id="gmap" /> */}
            <Map />
          </div>
        </div>
        <div className="search-page-right-wrap pd-bottom-70">
          <div className="search-page-right-side">
            <div className="row">
              <div className="col-sm-8">
                <div className="section-title">
                  <h4 className="title">Apartments</h4>
                </div>
              </div>
              <div className="col-sm-4">
                <ul className="nav nav-tabs rld-search-page-tab float-sm-right">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-toggle="tab"
                      href="#tabs_1"
                    >
                      <i className="fa fa-th" />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#tabs_2">
                      <i className="fa fa-list-ul" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="rld-main-search">
              <div className="row">
                <div className="colx col1">
                  <div className="rld-single-input left-icon">
                    <input type="text" placeholder="Entry Landmark Location" />
                  </div>
                </div>
                <div className="colx col2">
                  <div className="rld-single-select">
                    <select className="select single-select">
                      <option value={1}>All Properties</option>
                      <option value={2}>Properties 1</option>
                      <option value={3}>Properties 2</option>
                      <option value={3}>Properties 3</option>
                    </select>
                  </div>
                </div>
                <div className="colx col3">
                  <div className="rld-single-select">
                    <select className="select single-select">
                      <option value={1}>Room</option>
                      <option value={2}>Room 1</option>
                      <option value={3}>Room 2</option>
                      <option value={3}>Room 3</option>
                    </select>
                  </div>
                </div>
                <div className="colx col3">
                  <div className="rld-single-select">
                    <select className="select single-select">
                      <option value={1}>Any Price</option>
                      <option value={2}>Price 1</option>
                      <option value={3}>Price 2</option>
                      <option value={3}>Price 3</option>
                    </select>
                  </div>
                </div>
                <div className="colx col3">
                  <a className="btn btn-yellow" href="#">
                    SEARCH NOW
                  </a>
                </div>
              </div>
            </div>
            <div className="tab-content">
              <div className="tab-pane fade show active" id="tabs_1">
                <div className="row justify-content-center">
                  {propertyState.properties.map((item, i) => (
                    <div key={i} className="col-xl-4 col-sm-6">
                      <div className="single-feature">
                        <div className="thumb">
                          <img src={item.selectedFile[0]} alt="img" />
                        </div>

                        <div className="details">
                          <a href="#" className="feature-logo">
                            <img
                              src={publicUrl + "assets/img/icons/l3.png"}
                              alt={imagealt}
                            />
                          </a>
                          <p className="author">
                            <i className="fa fa-user" /> {item.authorName}
                          </p>
                          <h6 className="title">
                            <a href={item.url}>{item.title}</a>
                          </h6>
                          <h6 className="price">{item.totalPayment}</h6>
                          <del>{item.totalPayment}</del>
                          <ul className="info-list">
                            {item.keyFeatures.map((features, i) => (
                              <li key={i}>
                                <i className={features.icon} /> {features.title}
                              </li>
                            ))}
                            <li>
                              <img
                                src={publicUrl + "/assets/img/icons/7.png"}
                                alt={imagealt}
                              />{" "}
                              {item.area}{" "}
                            </li>
                          </ul>
                          <ul className="contact-list">
                            <li>
                              <a className="phone" href="#">
                                <i className="fa fa-phone" />
                              </a>
                            </li>
                            <li>
                              <a className="message" href="#">
                                <img
                                  src={publicUrl + "/assets/img/icons/8.png"}
                                  alt="img"
                                />
                              </a>
                            </li>
                            <li>
                              <Link
                                className="btn btn-yellow"
                                to={{
                                  state: { propertyDetails: item },
                                  pathname: "property-details",
                                }}
                              >
                                View Details
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="tab-pane fade" id="tabs_2">
                {searchlist.items.map((item, i) => (
                  <div key={i} className="single-feature style-two">
                    <div className="thumb">
                      <img src={publicUrl + item.image} alt="img" />
                    </div>
                    <div className="details">
                      <div className="details-wrap">
                        <a href="#" className="feature-logo">
                          <img src={publicUrl + item.icon} alt={imagealt} />
                        </a>
                        <p className="author">
                          <i className="fa fa-user" /> {item.authorname}
                        </p>
                        <h6 className="title">
                          <a href={item.url}>{item.title}</a>
                        </h6>
                        <h6 className="price">$350/mo</h6>
                        <del>$790/mo</del>
                        <ul className="info-list">
                          {item.features.map((features, i) => (
                            <li key={i}>
                              <i className={features.icon} /> {features.title}
                            </li>
                          ))}
                          <li>
                            <img
                              src={publicUrl + "/assets/img/icons/7.png"}
                              alt={imagealt}
                            />{" "}
                            {item.area}{" "}
                          </li>
                        </ul>
                        <ul className="contact-list">
                          <li>
                            <a className="phone" href="#">
                              <i className="fa fa-phone" />
                            </a>
                          </li>
                          <li>
                            <a className="message" href="#">
                              <img
                                src={publicUrl + "/assets/img/icons/8.png"}
                                alt="img"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              className="btn btn-yellow"
                              href="property-details.html"
                            >
                              View Details
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchMap;

mapboxgl.accessToken =
  "pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA";

class Map extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lng: 73.099501,
      lat: 33.522117,
      zoom: 14,
    };
  }

  componentDidMount() {
    const { lng, lat, zoom } = this.state;

    const map = new mapboxgl.Map({
      container: this.mapContainer,
      style: "mapbox://styles/mapbox/light-v10",
      center: [lng, lat],
      zoom,
    });

    map.on("move", () => {
      const { lng, lat } = map.getCenter();

      this.setState({
        lng: lng.toFixed(4),
        lat: lat.toFixed(4),
        zoom: map.getZoom().toFixed(2),
      });
    });
  }

  render() {
    const { lng, lat, zoom } = this.state;

    return (
      <div>
        {/* <div className="inline-block absolute top left mt12 ml12 bg-darken75 color-white z1 py6 px12 round-full txt-s txt-bold">
          <div>{`Longitude: ${lng} Latitude: ${lat} Zoom: ${zoom}`}</div>
        </div> */}
        <div
          style={{ height: "100vh" }}
          ref={(el) => (this.mapContainer = el)}
          className="absolute top right left bottom"
        />
      </div>
    );
  }
}
